import * as React from 'react';
export const stepForwardSvg = React.forwardRef(function stepForwardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 .275a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0v-14a.75.75 0 0 1 .75-.75ZM1.121.549A1.691 1.691 0 0 1 2.857.484l.117.07.004.002.001.001.004.003.018.012.07.045.262.173.941.62L7.18 3.325a2474.23 2474.23 0 0 0 4.713 3.1c1.14.74 1.142 2.448.003 3.19l.002.002-8.92 5.879-.004.003a1.689 1.689 0 0 1-1.854 0 1.93 1.93 0 0 1-.87-1.636V2.19c0-.702.346-1.305.871-1.64Zm1.031 1.26c-.074-.047-.146-.045-.223.004-.086.055-.179.178-.179.377v11.672a.43.43 0 0 0 .18.373c.083.053.155.052.227.005l8.915-5.877.005-.003a.394.394 0 0 0 .173-.339.395.395 0 0 0-.173-.34 2213.4 2213.4 0 0 1-4.723-3.104L3.45 2.664l-.941-.621-.263-.173-.07-.046-.017-.01-.004-.004h-.002v-.002Z',
    }),
  );
});
stepForwardSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stepForward = {
  category: 'icon',
  colorable: true,
  name: 'stepForward',
  svg: stepForwardSvg,
};
